export default __webpack_public_path__ + "static/media/gallery_00.cf4e904e.jpg";